
<template>
  <div> 
    <div id="relitu" style="width: 500px;height:400px;float: right;"></div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  export default {

    data() {
      return {
        charts: '',
      }
    },

    mounted() {
      this.$axios.get("/api/mapDistribution?limit=40").then(res => {
        let arrdatas = res.data.data;
        let outname = ["南海诸岛", '北京市', '天津市', '上海市', '重庆市', '河北省', '河南省', '云南省', '辽宁省', '黑龙江省', '湖南省', '安徽省', '山东省', '新疆维吾尔自治区', '江苏省', '浙江省', '江西省', '湖北省', '广西壮族自治区', '甘肃省', '山西省', '内蒙古自治区', '陕西省', '吉林省', '福建省', '贵州省', '广东省', '青海省', '西藏自治区', '四川省', '宁夏回族自治区', '海南省', '台湾省', '香港', '澳门'];
        let outvalue =[];
        for (var i = 0; i <outname.length;i++)
        {
          for (var j = 0; j <arrdatas.length; j++)
          {
            if(arrdatas[j].countryName == outname[i])
            {
              outvalue.push(arrdatas[j].value);
              break;
            }
          }
        }
        this.init("relitu",outname,outvalue)
    });
    },

    methods: {
      init(id,outname,outvalue) {
        var mapCode = require("../../assets/china.json");
        echarts.registerMap('china', mapCode);
        this.charts = echarts.init(document.getElementById(id))
       // var outname = ["南海诸岛", '北京市', '天津市', '上海市', '重庆市', '河北省', '河南省', '云南省', '辽宁省', '黑龙江省', '湖南省', '安徽省', '山东省', '新疆维吾尔自治区', '江苏省', '浙江省', '江西省', '湖北省', '广西壮族自治区', '甘肃省', '山西省', '内蒙古自治区', '陕西省', '吉林省', '福建省', '贵州省', '广东省', '青海省', '西藏自治区', '四川省', '宁夏回族自治区', '海南省', '台湾省', '香港', '澳门'];
       // var outvalue = [0, 524, 13, 140, 75, 13, 83, 11, 19, 15, 69, 260, 39, 4, 31, 104, 36, 1052, 33, 347, 9, 157, 22, 4, 18, 5, 6398, 41, 0, 484, 404, 22, 3, 5, 225];
        var outdata = [];
        for (var i = 0; i < outname.length; i++) {
          outdata.push({
            name: outname[i],
            value: outvalue[i]
          })
        }
        console.log('outdata---> ', outdata)
        let option = {
          tooltip: {
            show: true,
            formatter: function (params) {
              return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;' + params.value + '人&nbsp;&nbsp;';
            }
          },
           title : {
              text: '有效认证证书分布区域图',
              x:'center'
          },
          visualMap: {
            type: 'piecewise',
            left: '15',
            bottom: '15',
            itemWidth: 27,
            itemHeight: 15,
            textStyle: {
              color: '#333333',
              fontSize: 14,
            },
            pieces: [{
              min: 3000,
              label: '>3000',
            }, {
              max: 3000,
              min: 2000,
              label: '1000-3000',
            }, {
              max: 2000,
              min: 0,
              label: '<1000',
            }, {
              value: 0,
              label: '无数据',
            },],
            inRange: {
              color: ['#B2CAE0', '#D2EAFF', '#8AC6FD', '#45A5F8']
            },
            outOfRange: {
              color: ['#999999']
            }
          },
          geo: {
            map: 'china',
            show: true,
            roam: false,
            label: {
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                borderColor: 'rgba(0,63,140,0.2)',
                shadowColor: 'rgba(0,63,140,0.2)',
                shadowOffsetY: 20,
                shadowBlur: 30
              }
            }
          },
          series: [{
            type: 'map',
            map: 'china',
            aspectScale: 0.75,
            //zoom:1.1,
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#B2CAE0',
                borderColor: '#fff',
                borderWidth: 1,
              },
              emphasis: {
                areaColor: '#FFAE00',
              }
            },
            data: outdata
          }]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.charts.setOption(option);
      }
    },

  }
</script>
<style scoped>
.title-data{
    font-size:27px;
    margin:13px 13px;
    text-align: center;
  }

  .indexMapBottom .leftInfo {
    width: 46%;
    color: #FFFFFF;
    background: linear-gradient(to right,#a82f37,#ba59e4);
    border-radius: 2px 20px 20px 2px;
    float: left;
  }
  .indexMapBottom .rightInfo {
      width: 29%;
      color: #FFFFFF;
      background: linear-gradient(to right,#23c4e8,#015eab);
      border-radius: 20px 2px 2px 20px;
      float: right;
      margin-right: 1.5%;
  }
</style>